var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCard',{staticClass:"sp_card"},[_c('CCardBody',{staticClass:"p-4 card-body"},[_c('PrivacyPolicy')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }